// extracted by mini-css-extract-plugin
module.exports = {"notAdded":"favoriteicon-module--notAdded--c9lnq","hovered":"favoriteicon-module--hovered--3ZjJq","added":"favoriteicon-module--added--ulbuU"};